export const EMAIL_REQUIRED_ERROR = "Email is a required field";
export const EMAIL_INVALID_ERROR = "Email must be a valid email";

export const PASSWORD_REQUIRED_ERROR = "Password is a required field";
export const PASSWORD_INVALID_ERROR =
  "Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter and one number";

export const FIRST_NAME_REQUIRED_ERROR = "First name is a required field";

export const LAST_NAME_REQUIRED_ERROR = "Last name is a required field";

export const WORKSPACE_REQUIRED_ERROR = "Workspace is a required field";

export const WEBSITE_REQUIRED_ERROR = "Website is a required field";
export const WEBSITE_INVALID_ERROR = "Please enter a valid website link";

export const RATE_REQUIRED_ERROR = "Rate is a required field";
export const RATE_MIN_ERROR = "Rate must be greater than or equal to 0";

export const YEARS_OF_EXPERIENCE_REQUIRED_ERROR =
  "Years of experience is a required field";
export const YEARS_OF_EXPERIENCE_MIN_ERROR =
  "Years of experience must be greater than or equal to 0";

export const SKILLS_REQUIRED_ERROR = "Skills is a required field";

export const ENG_LEVEL_REQUIRED_ERROR = "English level is a required field";

export const START_DATE_REQUIRED_ERROR = "Start date is a required field";
export const START_DATE_FUTURE_ERROR = "Please choose today or future date";

export const DURATION_REQUIRED_ERROR = "Duration is a required field";
export const DURATION_MIN_ERROR = "Duration must be greater than or equal to 0";

export const WEEKLY_EMPLOYMENT_REQUIRED_ERROR =
  "Weekly employment is a required field";
export const WEEKLY_EMPLOYMENT_MIN_ERROR =
  "Weekly employment must be greater than or equal to 0";

export const LOCATION_REQUIRED_ERROR = "Location is a required field";

export const POSITION_REQUIRED_ERROR = "Position is a required field";

export const CV_LINK_REQUIRED_ERROR = "CV link is a required field";
export const CV_LINK_INVALID_ERROR = "Please enter a valid CV link";

export const TITLE_REQUIRED_ERROR = "Title is a required field";

export const MESSAGE_REQUIRED_ERROR = "Message is a required field";

export const TELEGRAM_AT_ERROR = "Your telegram shouldn't contain '@'";
